import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

// background jobs should align to backend backgroundJob.className
export type TValidBackgroundJob =
  | 'BulkStudentUpdate'
  | 'BulkStudentSupportUpdate'
  | 'BulkStudentSupportCreate'
  | 'BulkStudentPathCreate'
  | 'BulkStudentPathUpdate'
  | 'BulkStudentActivityCreate'
  | 'BulkStudentActivityUpdate'
  | 'BulkMilestoneUpdate';
export interface IMessage {
  backgroundJob: TValidBackgroundJob;
}

@Injectable({
  providedIn: 'root',
})
export class BackgroundJobNotificationService {
  private subject = new Subject<any>();

  sendMessage(message: IMessage) {
    this.subject.next(message);
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
